import { render, staticRenderFns } from "../template/web_login.html?vue&type=template&id=70fd49de&scoped=true&external"
import script from "./LiveLogin.vue?vue&type=script&lang=js"
export * from "./LiveLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fd49de",
  null
  
)

export default component.exports